import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import { ELoginPopupState, urls } from "../loginConstants";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import { Link, RouteChildrenProps } from "react-router-dom";
import LoginStatusScreen from "./loginStatusScreen";
import ForgotForm from "../forms/forgotForm";
import LoginService from "../../service/login/loginService";
import logo from "../../../assets/images/logo_white.jpg";

export interface IForgotScreenProps {}

export interface IForgotScreenState {
	popupMessage: string;
}

class ForgotScreen extends React.Component<IForgotScreenProps & RouteChildrenProps, IForgotScreenState> {
	state = { popupMessage: "" };

	get routeParam() {
		return this.props.match!.path.split("/")[2];
	}

	get title() {
		switch (this.routeParam) {
			case "forgot-password":
				return "Forgot Password";
			case "unblock-account":
				return "Unblock Account";
			case "forgot-yob":
				return "Get Your YOB";
			default:
				return "";
		}
	}

	onClose = () => {
		this.props.history.push("/login/help");
	};

	render() {
		return (
			<>
				<LoginPopup
					leftHeaderContent={
						<Link to="/login/help" className="ed_button link action icon_button">
							<i className="arrow_left edel-icon-arrow-left vTextTop" />
							<span>Back</span>
						</Link>
					}
					centerHeaderContent={
						DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : <h1 className="title">Forgot Login ID</h1>
					}
					// don't show close button in vendor login
					onClose={LoginService.hideCross ? undefined : this.onClose}
					className="login_scrn frgt_id_form"
				>
					{DeviceContext().isDesktop && (
						<div className="header">
							<h1 className="title">{this.title}</h1>
						</div>
					)}

					<ForgotForm onSuccess={(popupMessage) => this.setState({ popupMessage })} />
				</LoginPopup>
				{this.state.popupMessage && (
					<LoginStatusScreen
						popupState={ELoginPopupState.LOGINID_SENT}
						message={this.state.popupMessage}
						onClose={LoginService.hideCross ? undefined : this.onClose} // don't show close button in vendor login
					/>
				)}
			</>
		);
	}
}

export default ForgotScreen;
